/*    
<summary>
   This is a common component that shows SVG image of no data.
   Developer:Aashish Singh, Created Date:08-July-2025
</summary>
*/
import React from "react";

const CantAbortIconSVG: React.FC = () => {
  return (
    <svg
      id="Layer_1"
      enable-background="new 0 0 60 60"
      height="20"
      viewBox="0 0 60 60"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="m35.6877441 10.9489746c-1.2289429-1.9899902-3.3599854-3.1790161-5.6999512-3.1790161-2.3400269 0-4.4689941 1.1890259-5.7189941 3.2189941l-17.2600097 31.0310059c-1.2999878 2.098999-1.3510132 4.6390381-.151001 6.7900391 1.2009888 2.1389771 3.3800049 3.4199829 5.8510132 3.4199829h34.5899658c2.460022 0 4.6389771-1.2810059 5.8400269-3.4199829 1.1999512-2.151001 1.1489868-4.69104-.1199951-6.75zm1.7710572 27.3909912c.1889648.1799927.2999878.4390259.2999878.6990356 0 .2709961-.1110229.5209961-.2999878.7099609l-2.4400024 2.44104c-.3900146.3999634-1.0210571.3999634-1.4110107 0l-3.6100464-3.6000366-3.5999756 3.6090088c-.1889648.190979-.4389648.289978-.710022.289978-.2689819 0-.5189819-.098999-.7089844-.289978l-2.4509888-2.4500122c-.3889771-.3889771-.3889771-1.0189819 0-1.4089966l3.6110229-3.6099854-3.6010132-3.5999756c-.1890259-.1900024-.2999878-.4400024-.2999878-.7109985 0-.269043.1109619-.519043.2999878-.710022l2.440979-2.4390259c.1900024-.190979.4400024-.289978.7089844-.289978.2710571 0 .5210571.098999.710022.289978l3.5999756 3.598999 3.6100464-3.6089478c.3899536-.3910522 1.0209961-.3910522 1.4110107 0l2.4499512 2.4489746c.3890381.3909912.3890381 1.0299683 0 1.4210205l-3.6109619 3.5999756z" />
    </svg>
  );
};

export default CantAbortIconSVG;
